/* ============================================
   CARRUSEL DE PRODUCT CARD - CON SOPORTE PAGINACIÓN
   ============================================ */

class ProductCardCarousel {
  constructor(element) {
    this.carousel = element;
    this.track = this.carousel.querySelector('.carousel-track');
    this.indicators = this.carousel.querySelectorAll('.indicator');
    this.slides = this.carousel.querySelectorAll('.carousel-slide');
    this.currentIndex = 0;
    this.startX = 0;
    this.currentX = 0;
    this.isDragging = false;
    this.autoAdvanceTimer = null;
    this.progressDuration = 2000;
    this.isHovering = false;
    this.isInitialized = false;
    
    if (this.slides.length > 1 && this.track) {
      this.init();
    }
  }
  
  init() {
    if (this.isInitialized) return;
    this.isInitialized = true;
    
    // Swipe para mobile - con mejor detección
    let touchStartTime = 0;
    
    this.carousel.addEventListener('touchstart', (e) => {
      if (e.target.closest('.indicator')) return;
      
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
      touchStartTime = Date.now();
      this.stopAutoAdvance();
    }, { passive: true });
    
    this.carousel.addEventListener('touchmove', (e) => {
      if (!this.isDragging) return;
      this.currentX = e.touches[0].clientX;
      
      const diff = Math.abs(this.startX - this.currentX);
      if (diff > 10) {
        e.preventDefault();
      }
    }, { passive: false });
    
    this.carousel.addEventListener('touchend', (e) => {
      if (!this.isDragging) return;
      
      const diff = this.startX - this.currentX;
      const touchDuration = Date.now() - touchStartTime;
      
      if (Math.abs(diff) > 30 || (Math.abs(diff) > 15 && touchDuration < 300)) {
        if (diff > 0 && this.currentIndex < this.slides.length - 1) {
          this.goToSlide(this.currentIndex + 1, false);
        } else if (diff < 0 && this.currentIndex > 0) {
          this.goToSlide(this.currentIndex - 1, false);
        }
      }
      
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;
    });
    
    // Hover/touch en indicadores
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener('mouseenter', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToSlide(index, true);
      });
      
      indicator.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToSlide(index, false);
      });
      
      indicator.addEventListener('touchstart', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goToSlide(index, false);
      }, { passive: false });
      
      indicator.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
 // Desktop: desactivar auto-avance, mantener slide actual al salir del hover
if (window.innerWidth >= 750) {
  this.carousel.addEventListener('mouseleave', () => {
    this.isHovering = false;
    this.stopAutoAdvance();
    // Ya no vuelve al slide 0, se queda donde está
  });
}
  }
  
  startAutoAdvance() {
    if (!this.isHovering) return;
    this.stopAutoAdvance();
    
    this.autoAdvanceTimer = setTimeout(() => {
      if (!this.isHovering) return;
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, true);
    }, this.progressDuration);
  }
  
  stopAutoAdvance() {
    if (this.autoAdvanceTimer) {
      clearTimeout(this.autoAdvanceTimer);
      this.autoAdvanceTimer = null;
    }
  }
  
  goToSlide(index, continueAutoAdvance = false) {
    this.stopAutoAdvance();
    this.currentIndex = index;
    
    if (this.track) {
      this.track.style.transform = `translateX(-${index * 100}%)`;
    }
    
    this.indicators.forEach((ind, i) => {
      ind.classList.remove('active');
    });
    
    if (this.indicators[index]) {
      this.indicators[index].classList.add('active');
    }
    
    if (continueAutoAdvance && this.isHovering) {
      this.startAutoAdvance();
    }
  }
  
  destroy() {
    this.stopAutoAdvance();
    this.isInitialized = false;
  }
}

// Almacenar instancias
const carouselInstances = new WeakMap();

// Inicializar carruseles
function initCarousels() {
  const carousels = document.querySelectorAll('.product-card__carousel');
  
  carousels.forEach(carousel => {
    // Si ya tiene instancia, destruirla primero
    if (carouselInstances.has(carousel)) {
      const instance = carouselInstances.get(carousel);
      instance.destroy();
    }
    
    // Crear nueva instancia
    const instance = new ProductCardCarousel(carousel);
    carouselInstances.set(carousel, instance);
  });
}

// Limpiar carruseles que ya no existen en el DOM
function cleanupCarousels() {
  const currentCarousels = document.querySelectorAll('.product-card__carousel');
  const currentSet = new Set(currentCarousels);
  
  // Esta parte es solo para mantener limpia la memoria
  // WeakMap se encarga automáticamente, pero es buena práctica
}

// Inicialización inicial
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCarousels);
} else {
  initCarousels();
}

// CRÍTICO: Detectar cambios de paginación
// Escuchar clicks en links de paginación
document.addEventListener('click', (e) => {
  const paginationLink = e.target.closest('a[href*="page="], .pagination a, [class*="pagination"] a');
  if (paginationLink) {
    // Esperar a que se cargue el nuevo contenido
    setTimeout(() => {
      initCarousels();
    }, 500);
    
    // Intentar de nuevo por si tarda más
    setTimeout(() => {
      initCarousels();
    }, 1000);
  }
});

// Detectar cuando cambia la URL (para paginación con AJAX)
let lastUrl = location.href;
new MutationObserver(() => {
  const url = location.href;
  if (url !== lastUrl) {
    lastUrl = url;
    setTimeout(() => {
      initCarousels();
    }, 300);
  }
}).observe(document, { subtree: true, childList: true });

// Eventos de Shopify
document.addEventListener('shopify:section:load', () => {
  setTimeout(initCarousels, 100);
});

document.addEventListener('shopify:section:reorder', () => {
  setTimeout(initCarousels, 100);
});

// Para temas con infinite scroll o filtros AJAX
const ajaxObserver = new MutationObserver((mutations) => {
  let shouldInit = false;
  
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.classList?.contains('product-card__carousel') || 
            node.querySelector?.('.product-card__carousel') ||
            node.classList?.contains('product-card') ||
            node.querySelector?.('.product-card')) {
          shouldInit = true;
        }
      }
    });
  });
  
  if (shouldInit) {
    setTimeout(initCarousels, 100);
  }
});

// Observar contenedores comunes de productos
setTimeout(() => {
  const containers = document.querySelectorAll('.collection, .search, [class*="product-list"], [class*="product-grid"], main, #MainContent');
  containers.forEach(container => {
    if (container) {
      ajaxObserver.observe(container, {
        childList: true,
        subtree: true
      });
    }
  });
}, 500);

// Forzar reinicialización cada vez que se hace scroll (para lazy loading)
let scrollTimeout;
window.addEventListener('scroll', () => {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    const uninitializedCarousels = document.querySelectorAll('.product-card__carousel:not([data-carousel-ready])');
    if (uninitializedCarousels.length > 0) {
      initCarousels();
    }
  }, 200);
}, { passive: true });
